export const ListaValorConstants = {
  TipoDocumentoIca: 'ICA_TIPO_DOCUMENTO',
  TipoSociedadIca: 'ICA_TIPO_SOCIEDAD',
  TipoEspecieIca: 'ICA_TIPO_ESPECIE',
  EstadosSegundaInstancia: 'ESTADO_SEGUNDA_INSTANCIA',
};
